// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26E7Y","title":"styles_title__xm11U"};